export default "__VITE_ASSET__tfbSKnuM__"